import React from "react"
import classnames from "classnames"
import { Link } from "react-router-dom";

class Button extends React.Component {
  render() {
    const {
      className,
      children,
      link,
      to,
      type,
      small,
      ghost,
      onClick,
    } = this.props
    const buttonBasic = "a-button"
    const buttonClass = classnames(
      buttonBasic,
      { "a-button--primary": !type },
      { [`a-button--${type}`]: type },
      { [`a-button--small`]: small },
      { [`a-button--ghost`]: ghost },
      className
    )

    if (to) {
      return (
        <Link to={to} onClick={onClick} className={buttonClass}>
          {children}
        </Link>
      )
    }

    if (link) {
      return (
        <a href={link} onClick={onClick} className={buttonClass}>
          {children}
        </a>
      )
    }

    return (
      <button onClick={onClick} className={buttonClass} type="button">
        {children}
      </button>
    )
  }
}

export default Button
